<div class="sub-menu" *ngrxLet="filteredUserOrganizations$;let filteredUserOrganizations">
  <div class="overlay" (click)="onMenuClosed.emit()">

  </div>
  <div class="sub-menu-inner" style="width:256px" [class.left]="position==='left'" [class.right]="position === 'right'">
    <div class="inner h-100">
      <div class="active-organization organization-item title flex-row start-center gap-8">
        <ui-avatar class="org-avatar"
                   [name]="activeOrganization?.orgName"
                   [color]="activeOrganization?.orgColor"
        ></ui-avatar>
        <div uiTruncateText class="truncated-name">
          {{ activeOrganization?.orgName }}
        </div>

      </div>
      <hr class="hr" style="margin: 12px 8px 12px 8px">
      <div *ngIf="userOrganizations?.length>8" class="mt-8">
        <ui-search [placeholder]="'SIDEBAR.SEARCH_ORGANIZATION_PLACEHOLDER'|translate"
                   #uiSearchComponent
                   [heightPx]="40"
                   (onInput)="onSearchOrganizationInput($event)"
        ></ui-search>
      </div>
      <div class="flex-col h-100 organization-list-wrapper">
        <div class="flex-row start-center organization-item list gap-8"
             *ngFor="let organization of filteredUserOrganizations"
             (click)="switchOrg(organization.id)"

        >
          <ui-avatar class="org-avatar selectable"
                     [name]="organization.name"
                     [color]="organization.color"
                     [fontSize]="10"
          ></ui-avatar>
          <ui-truncated-html class="truncated-name">
            {{ organization.name }}
          </ui-truncated-html>
        </div>
      </div>
      <hr class="hr" style="margin: 0px 8px 8px 8px">
      <div class="button-wrapper">
        <ui-button [text]="'SIDEBAR.ORG_MENU.CREATE_NEW_ORG'|translate" type="secondary" (click)="createOrganization()">
        </ui-button>
      </div>
    </div>
  </div>
</div>
